import { render } from "./features-showcase.vue?vue&type=template&id=0bf77260&scoped=true&ts=true"
import script from "./features-showcase.vue?vue&type=script&lang=ts"
export * from "./features-showcase.vue?vue&type=script&lang=ts"

import "./features-showcase.vue?vue&type=style&index=0&id=0bf77260&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf77260"]])

export default __exports__